import { FaChevronUp, FaChevronDown, FaTrash } from "react-icons/fa";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { Button, Image, Loader } from "../../../components/shared";
import { getImageUrl } from "../../../lib/get-image";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const CartMainContent = ({
  cartItems,
  isLoading,
  removeItem,
  updateQuantityInc,
  updateQuantityDec,
  styles,
    selectedItems,
  handleSelectItem,
}) => { 
  const navigate = useNavigate();
  return (
    <>
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Loader title="Loading carts data.." />
        </div>
      ) : cartItems?.length === 0 ? (
     <div className={styles.emptyCartWrapper}>
  <p className={styles.emptyCartText}>
    Please add product to proceed
  </p>

  <button
    className={styles.continueShoppingBtn}
    onClick={() => navigate("/shop")}
  >
    Continue Shopping
  </button>
</div>
      ) : (
        <div className={styles.cartSection}>
          <div className={styles.tableHeader}>
              <div>Select</div>
            <div>Remove</div>
            {/* <div>Images</div> */}
            <div>Product</div>
            <div>Unit Price</div>
            <div>Quantity</div>
            <div>Total</div>
          </div>
          {cartItems.map((item) => {
            const maxQty = item?.product?.qty || 0;
            const isMaxReached = item.quantity >= maxQty;
            return (
              <div key={item.id} className={styles.cartItem}>
                <input
  type="checkbox"
  checked={selectedItems.includes(item.id)}
  onChange={() => handleSelectItem(item.id)}
/>
             
                <FaTrash
                  size={18}
                  className={styles.removeBtn}
                  onClick={() => {
                    toast.success("Item removed from cart");
                    removeItem(item.id);
                  }}
                />
              
                <Link to={`/productdetails/${item.product.slug}`}>
                  <Image
                    src={getImageUrl(item.product.thumb_image)}
                    alt={item.product.name}
                    className={styles.productImage}
                  />
                </Link>
              
                <Link to={`/productdetails/${item.product.slug}`}>
                  {item.product.name} ({item.product.sku})
                </Link>
               
 <div className={styles.priceCell}>
  {(() => {
    const price = Number(item.product.price);

    // ✅ IMPORTANT FIX: do NOT convert empty/null to 0
    const offer =
      item.product.offer_price !== null &&
      item.product.offer_price !== undefined &&
      item.product.offer_price !== ""
        ? Number(item.product.offer_price)
        : null;

    const hasOffer = offer !== null && offer < price;

    const finalPrice = hasOffer ? offer : price;

    const discountPercent = hasOffer
      ? Math.round(((price - offer) / price) * 100)
      : 0;

    return (
      <div className={styles.priceBlock}>
        {/* Final price (always show only ONE main price) */}
        <div className={styles.finalPrice}>
          <LiaRupeeSignSolid size={14} />
          {finalPrice}
        </div>

        {/* Show original + discount ONLY if valid offer exists */}
        {hasOffer && (
          <div className={styles.priceMeta}>
            <span className={styles.originalPrice}>
              <LiaRupeeSignSolid size={12} />
              {price}
            </span>

            <span className={styles.discountBadge}>
              {discountPercent}% OFF
            </span> 
          </div>
        )}
      </div>
    );
  })()}
</div>
              
                <div className={styles.quantityInputWrapper}>
                  <input
                    readOnly
                    type="number"
                    value={item.quantity}
                    className={styles.quantityInputField}
                  />
                  <div className={styles.quantityArrows}>
                 
                    <Button
                      style={styles.arrowBtn}
                      disabled={isMaxReached}
                      title={<FaChevronUp size={10} />}
                      onHandler={() => {
                        if (isMaxReached) return;
                        updateQuantityInc(item.product_id);
                      }}
                    />
              
                    <Button
                      style={styles.arrowBtn}
                      disabled={item.quantity <= 1}
                      title={<FaChevronDown size={10} />}
                      onHandler={() =>
                        updateQuantityDec(
                          item.product_id,
                          item.quantity
                        )
                      }
                    />
                  </div>
                </div>
            
              <div>
  <LiaRupeeSignSolid size={16} />
  {(item.product.offer_price || item.product.price) * item.quantity}
</div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default CartMainContent;